// Site-wide feature flags — plain code-level constants (not DB settings) so server AND
// client components can read them with zero plumbing/requests. Flip + deploy to change.

// The "live WhatsApp message typing itself" preview widgets (2026-07-29, user request:
// disabled but PRESERVED). Covers three surfaces, all gated on this one flag:
//   1. WaSmartButton's full bubble mode — the WA-chat-style bubble with the typewriter
//      reveal + "typing…" dots (pro cards, pro-page ContactFrame, OtherExperts).
//      When off it renders a plain green send button instead — same ContactModal flow,
//      no theater.
//   2. CompactWaBar — the pinned bottom "scroll sticker" bar with the same live preview.
//   3. CompactIntake's InlineWaPreview — the in-card preview bubble.
// The strategy moved to questionnaire-first + composed per-pro messages via the /wa/
// short-link engine (lib/waLinks.ts) — the visitor answers article-specific questions
// and we compose the message for them, so the "watch your message being typed" theater
// is no longer the flow. ALL the code/design is intact behind this flag; docs:
// docs/wa-typing-preview-disabled.md. Set true + build to bring it all back.
export const WA_TYPING_PREVIEW_ENABLED = false;

// "Get more quotes" / OtherExperts widget on the pro profile page (2026-07-30, user
// request: disabled but PRESERVED). Each same-category expert got a per-pro "שליחת
// ההודעה שלי ל{firstName}" WhatsApp button — user reports this duplicates the
// questionnaire-first flow already covering the same job (compose once, route to the
// right pro via the /wa/ short-link engine), AND it had a real display bug: one
// expert's button showed "לישראל" (a fallback/placeholder value) instead of a real
// first name. Root cause of the name bug was not investigated further since the whole
// widget is being retired in favor of the questionnaire flow, not patched. Code is
// intact in components/OtherExperts.tsx — set true + build to bring it back.
export const OTHER_EXPERTS_WIDGET_ENABLED = false;

// Per-professional contact gate in ContactModal.tsx (2026-07-30, user request).
// WA_FIRST engine (active) — matches the questionnaire's own contact pattern
// (lib/waLinks.ts): the visitor sends ONE WhatsApp message to OUR company number first
// (captures their phone + intent, zero SMS cost, no OTP friction). That message contains
// a tracked /wa/<code> and/or /tel/<code> link that redirects to the pro's real
// phone/wa.me only once the visitor clicks it from inside their own WhatsApp chat with
// us. "Already sent" state persists per-pro via lib/contactedState.ts, same mechanism
// the buttons already used for their "✅ opened" state.
//
// The OLD engine (OTP verification — visitor types THEIR OWN phone, we SMS them a
// 4-digit code, they enter it, only then the pro's real phone/wa.me link is revealed)
// was removed from the codebase 2026-09-09 — it was fully dead (already disabled, and
// ContactModal.tsx itself isn't rendered by any live component) and its code paths
// could fall back to raw, untracked pro links. Archived at
// docs/archive/otp-verification-2026-09-09/ (see its README to restore).
